export var ActivityType;
(function (ActivityType) {
    ActivityType["UPDATE_WEIGHT"] = "updateWeight";
    ActivityType["UPDATE_PREGNANCY_STATUS"] = "updatePregnancyStatus";
    ActivityType["UPDATE_DECEASE_STATUS"] = "updateDeceaseStatus";
    // EDIT_USER = 'edit_user',
    ActivityType["TRANSFER"] = "TRANS_token";
    // SUBMIT_ENVD = 'submit_envd',
    ActivityType["LINK_PRODUCT"] = "linkProduct";
    ActivityType["LINK_TOKEN"] = "linkToken";
    ActivityType["LINK_USER"] = "linkUser";
    ActivityType["LINK_BUSINESS"] = "linkBusiness";
    ActivityType["OUT_CONSIGNMENT"] = "outConsignment";
    ActivityType["ADD_CONSIGNMENT_SETTING"] = "addConsignmentSetting";
    ActivityType["ADD_FILE"] = "addFile";
    ActivityType["DELETE_TOKEN"] = "DEL_token";
    ActivityType["UPDATE_TOKEN"] = "UP_details";
    ActivityType["DELETE_DETAILS"] = "DEL_details";
    ActivityType["MOVE"] = "move";
    ActivityType["INVITE_USER"] = "invite_user";
    ActivityType["UPDATE_USER"] = "UP_user_details";
    ActivityType["ACTIVATE_USER"] = "activate_user";
    ActivityType["DEACTIVE_USER"] = "deactivate_user";
})(ActivityType || (ActivityType = {}));
// front end error
// API error: Aglive API; Third-party API;
// Blockchain error
export const error_case = [
    // API error
    // API: PUT TOKEN ID
    {
        code: 400,
        type: 'E_TOKEN_UPDATE_TOKENID_TOKENID_EMPTY',
        title: 'Token ID Empty',
        message: 'Token ID is not included in the request.',
        description: 'It happens when the request does not include token ID. API: PUT TOKEN ID',
    },
    {
        code: 400,
        type: 'E_TOKEN_CREATE_DUPLICATE_TOKENID',
        title: 'Token ID Duplicate',
        message: 'Token ID is duplicated.',
        description: 'It happens when the token ID has already existed. API: PUT TOKEN ID',
    },
    {
        code: 400,
        type: 'E_TOKEN_UPDATE_TOKENID_TOKEN_NOT_FOUND',
        title: 'External ID Not Found',
        message: 'External ID is not found.',
        description: 'It happens when the external ID is not existed. API: PUT TOKEN ID',
    },
    {
        code: 400,
        type: 'E_TOKEN_UPDATE_TOKENID_EXTERNALIDS_EMPTY',
        title: 'External ID Empty',
        message: 'External ID is empty.',
        description: 'It happens when the request does not include external ID. API: PUT TOKEN ID',
    },
    {
        code: 400,
        type: 'E_TOKEN_ID_UPDATE_USERID_EMPTY',
        title: 'User ID Empty',
        message: 'User ID is empty.',
        description: 'It happens when the request does not include user ID. API: PUT TOKEN ID',
    },
    // POST TOKEN
    {
        code: 400,
        type: 'E_TOKEN_CREATE_DUPLICATE_UNIQUE_EXTERNAL_ID',
        title: 'Duplicate Unique Id',
        message: 'The unique external id is duplicated.',
        description: 'It happens when the scanned external id has been registered in the system. API: POST TOKEN',
    },
    {
        code: 400,
        type: 'E_TOKEN_CREATE_USERID_EMPTY',
        title: 'User ID Empty',
        message: 'User ID is empty.',
        description: 'It happens when the request does not include user ID. API: POST TOKEN',
    },
    {
        code: 400,
        type: 'E_TOKEN_CREATE_USER_NOT_EXIST',
        title: 'User Not Exist',
        message: 'User is not registered, please register your account.',
        description: 'It happens when the user is not registered. API: POST TOKEN',
    },
    // POST TOKEN BY CSV
    {
        code: 400,
        type: 'Error_Dup_In_DB',
        title: 'Duplicate External ID in CSV File',
        message: 'The CSV file includes the external ID that has already been registered.',
        description: 'It happens when the external ID in the CSV files has already been registered. API: POST TOKEN BY CSV',
    },
    // POST ACTIVITY BY CSV
    {
        code: 400,
        type: 'Error_Not_Exist_In_DB',
        title: 'External ID in CSV File Not Exist',
        message: 'The CSV file includes the external ID that has not been registered.',
        description: 'It happens when the external ID in the CSV files has not been registered. API: POST ACTIVITY BY CSV',
    },
    // POST EXPORT CSV
    {
        code: 400,
        type: 'E_USER_NOT_FOUND',
        title: 'User Not Exist',
        message: 'User is not registered, please register your account.',
        description: 'It happens when the user is not registered. API: POST EXPORT CSV',
    },
    // POST UPLOADER
    {
        code: 400,
        type: 'E_UPLOAD_CATEGORY_NOT_VALID',
        title: 'Category Not Valid',
        message: 'Category is not valid.',
        description: 'It happens when the category is not valid. API: POST UPLOADER',
    },
    // POST GET TOKEN BY TOKEN ID
    {
        code: 400,
        type: 'E_TOKEN_ID_NOT_FOUND',
        title: 'Token ID Not Found',
        message: 'Token ID is not found.',
        description: 'It happens when the token ID is not existed. API: POST GET TOKEN BY TOKEN ID',
    },
    {
        code: 400,
        type: 'E_TOKEN_ID_DUPLICATE_FOUND',
        title: 'Duplicate Token ID Not Found',
        message: 'More than one token ID have been found.',
        description: 'It happens when more than one token ID have been found. API: POST GET TOKEN BY TOKEN ID',
    },
    // POST GET TOKEN BY EXTERNAL ID
    {
        code: 400,
        type: 'E_EXTERNAL_ID_TOKEN_NOT_FOUND',
        title: 'Token External ID Not Found',
        message: 'Token external ID is not found.',
        description: 'It happens when the token external ID is not existed. API: POST GET TOKEN BY EXTERNAL ID',
    },
    // POST GET TOKEN BY USER ID
    {
        code: 400,
        type: 'E_USER_ID_TOKEN_NOT_FOUND',
        title: 'User Not Found',
        message: 'User is not registered, please register your account.',
        description: 'It happens when the user is not registered. API: POST GET TOKEN BY USER ID',
    },
    {
        code: 400,
        type: 'E_GET_TOKEN_USER_ID_EMPTY',
        title: 'User ID Empty',
        message: 'User ID is empty, please check your account.',
        description: 'It happens when the request does not include user ID.  API: POST GET TOKEN BY USER ID',
    },
    // OTHER REQUEST ERROR
    {
        code: 400,
        type: 'E_REQUEST_ERROR',
        title: 'Request Error',
        message: 'The request has error.',
        description: 'It happens when client cannot make requests.',
    },
    {
        code: 400,
        type: 'Error_Bad_Request',
        title: 'Bad Request',
        message: 'The request body is wrong.',
        description: 'It happens when the client provides the incorrect request body.',
    },
    {
        code: 400,
        type: 'E_UNEXPECT',
        title: 'Unexpected Error',
        message: 'Unexpected Error.',
        description: 'Unexpected Error',
    },
    // for envd validation
    {
        code: 500,
        type: 'Error_Details_Incorrect',
        title: '',
        message: 'Credentials of nlis, lpa are not correct.',
        description: '',
    },
    // blockchain error
    // BC transferToken
    {
        code: 400,
        type: 'gas required exceeds allowance (8000000) or always failing transaction',
        title: 'Blockchain Transfer Fail',
        message: 'The token you are transferring is not belong to your account.',
        description: '',
    },
    // BC createToken
    {
        code: 400,
        type: 'insufficient funds (version=4.0.48)',
        title: 'Blockchain Operation Fail',
        message: 'Your account has insufficient funds.',
        description: '',
    },
    // network error:
    // API
    {
        code: 500,
        type: 'E_REQUEST_MADE_NO_RESPONSE',
        title: 'No Response',
        message: 'The request was made but no response was received.',
        description: 'It happens when client has request, but the server is not responding.',
    },
    // blockchain
    {
        code: 500,
        type: 'invalid response - 0',
        title: 'Network Not Connected',
        message: 'Your network is not connected.',
        description: 'This happens when the network is not connected, returned from web3.',
    },
];
